import { mergeRight, concat } from 'ramda'
import { SegmentModel } from 'components/ContactFilterBuilder/constants/SegmentModel'
import { ActionTypes } from 'modules/filter_builder/actions'

const defaultState = {
  contact: [],
  events: [],
  playbooks: [],
  playbookEvents: [],
  playbookEventLibrary: [],
  segment: null,
  tags: [],
  playbook: null,
  previousView: null,
  view: 'Selection',
  defaultSegment: SegmentModel,
  filterIndex: 0,
  groupIndex: 0,
}

const properties = (state = defaultState, action) => {
  switch (action.type) {
    case ActionTypes.RECEIVE_CONTACT_PROPERTIES:
      return mergeRight(state, {
        contact: [...action.properties]
      })

    case ActionTypes.RECEIVE_EVENT_PROPERTIES:
      return mergeRight(state, {
        events: [...action.properties]
      })

    case ActionTypes.RECEIVE_PLAYBOOKS:
      return mergeRight(state, {
        playbooks: action.playbooks
      })

    case ActionTypes.RECEIVE_PLAYBOOK_EVENTS:
      return mergeRight(state, {
        playbookEvents: [...action.playbookEvents],
        playbookEventLibrary: concat(state.playbookEventLibrary, action.playbookEvents)
      })

    case ActionTypes.RECEIVE_TAGS:
      return mergeRight(state, {
        tags: [...action.tags]
      })

    case ActionTypes.ADD_NEW_FILTER: {
      const nextFilterIndex = state.segment.segmentGroups[action.groupIndex].filters.length

      return mergeRight(state, {
        filterIndex: nextFilterIndex,
        groupIndex: action.groupIndex,
      })
    }

    case ActionTypes.ADD_NEW_GROUP: {
      const nextGroupIndex = state.segment.segmentGroups.length

      return mergeRight(state, {
        filterIndex: 0,
        groupIndex: nextGroupIndex,
      })
    }

    case ActionTypes.EDIT_FILTER_PROPERTY: {
      return mergeRight(state, {
        filterIndex: action.filterIndex,
        groupIndex: action.groupIndex,
      })
    }

    case ActionTypes.EDIT_FILTER_VALUE: {
      return mergeRight(state, {
        filterIndex: action.filterIndex,
        groupIndex: action.groupIndex,
      })
    }

    case ActionTypes.RESET_FILTER_AND_GROUP_INDEX: 
      return mergeRight(state, {
        filterIndex: null,
        groupIndex: null,
      })

    case ActionTypes.CHANGE_VIEW: {
      const didViewChange = action.view !== state.view
      const newPreviousView = didViewChange ? state.view : state.previousView

      return {
        ...state,
        view: action.view,
        previousView: newPreviousView,
      }
    }

    case ActionTypes.RETURN_TO_PREVIOUS_VIEW: 
      return mergeRight(state, {
        view: state.previousView
      })

    case ActionTypes.SET_PLAYBOOK: 
      return mergeRight(state, {
        playbook: action.playbook
      })

    case ActionTypes.CHANGE_SEGMENT:
      return mergeRight(state, {
        segment: action.segment
      })

    case ActionTypes.MODIFY_FILTER_REFERENCE_LIBRARY:
      return mergeRight(state, {
        filterReference: action.filterReference
      })

    case ActionTypes.CLOSE_FILTER_BUILDER:
      return state

    case ActionTypes.SAVE_SEGMENT:
      return defaultState
      
    default:
      return state
  }
}

export default properties